import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Article } from '../../../components/canvasflow/article/Article';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ResponsiveModeContext } from './ResponsiveModeContext';
import SwiperCore, { EffectFade } from 'swiper/core';

import cssStyles from './ResponsiveMode.module.css';

SwiperCore.use([EffectFade]);

// Import Swiper styles
import 'swiper/swiper.scss';
import { AppContext } from '../../../services/AppContext';
import { useEffect } from 'react';
export const Carousel = (props) => {
	const { styles } = useContext(AppContext);
	let {
		articles,
		fontSize,
		article,
		onTransitionEnd,
		swiper,
		setSwiper,
		onLightboxMode,
		isLightboxMode,
		isTouchDevice,
		lang,
		onLightboxTargetClick,
	} = useContext(ResponsiveModeContext);
	const { index } = article;
	if (props.onTransitionEnd) {
		onTransitionEnd = props.onTransitionEnd;
	}

	useEffect(() => {
		if (!swiper) {
			return null;
		}
		swiper.slideTo(index, 750, false);
	}, [index, article]);

	const allowToMove = isTouchDevice && !isLightboxMode;

	useEffect(() => {
		if (!swiper) {
			return null;
		}
		const toggle = () => {
			if (!swiper) {
				return;
			}
			try {
				if (allowToMove) {
					swiper.enable();
				} else {
					swiper.disable();
				}
			} catch (e) {
				console.error(e);
				toggle();
			}
		};
		toggle();
	}, [isLightboxMode]);

	return (
		<div className={cssStyles['swiper-container']}>
			<Swiper
				updateOnWindowResize={true}
				initialSlide={index}
				scrollbar={{
					draggable: false,
				}}
				onSwiper={(s) => {
					/*s.on('mousedown touchstart pointerdown', (e) => {
						e.stopPropagation();
					});*/
					setSwiper(s);
				}}
				onSlideChange={(s) => {
					const { activeIndex } = s;
					onTransitionEnd({
						index: activeIndex,
					});
				}}
			>
				{articles.map(({ id, style, components, ArticleID }, i) => {
					let isVoid = isArticleVoid({
						total: articles.length,
						currentIndex: index,
						index: i,
					});

					// The article is not currently selected
					if (i !== index) {
						components = clone(
							components.filter(
								(component) => component.component !== 'video'
							)
						);
					}

					return (
						<SwiperSlide
							key={id}
							className={cssStyles['article-swiper']}
						>
							<Article
								id={id}
								ArticleID={ArticleID}
								index={i}
								style={`${style}`}
								lang={lang}
								isVoid={isVoid}
								fontSize={fontSize}
								styles={styles}
								isTouchDevice={isTouchDevice}
								components={components}
								onLightboxMode={onLightboxMode}
								onLightboxTargetClick={onLightboxTargetClick}
							/>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</div>
	);
};

Carousel.propTypes = {
	onTransitionEnd: PropTypes.func,
};

export function isArticleVoid2({ currentIndex, index }) {
	return currentIndex !== index;
}

export function isArticleVoid({ total, currentIndex, index }) {
	if (total > 5) {
		const lastArticleIndex = total - 1;
		if (currentIndex === 0) {
			// First and second page
			if (index !== 0 && index !== 1 && index !== 2) {
				return true;
			}
		} else if (currentIndex === lastArticleIndex) {
			// Last 2 articles
			if (
				index !== lastArticleIndex &&
				index !== lastArticleIndex - 1 &&
				index !== lastArticleIndex - 2
			) {
				return true;
			}
		} else {
			if (
				index !== currentIndex &&
				index !== currentIndex - 1 &&
				index !== currentIndex - 2 &&
				index !== currentIndex + 1 &&
				index !== currentIndex + 2
			) {
				return true;
			}
		}
	}
	return false;
}

function clone(obj) {
	if (structuredClone) {
		return obj;
	}

	return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}
